import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "shareMobile",
  "use": "shareMobile-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\" id=\"shareMobile\"><path d=\"m18 36c9.9411 0 18-8.0589 18-18 0-9.94113-8.0589-18-18-18-9.94113 0-18 8.05887-18 18 0 9.9411 8.05887 18 18 18z\" fill=\"#9c7446\" /><g fill=\"#f6efeb\"><path d=\"m16.4859 11.0333.8167-1.51663v9.91663h1.4v-9.91663l.8167 1.51663 2.1 2.2167 1.05-1.05-4.6667-4.2-4.6667 4.2 1.05 1.05z\" /><path d=\"m25 15.3516h-1.5167v8.9833h-10.9666v-8.9833h-1.5167v10.5h14z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol